<template>
  <v-container fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md5>
        <v-alert :value="error" dismissible type="error">Los datos ingresados no son válidos</v-alert>
        <template v-if="loading">
          <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
          <br>
          <h4 class="texto">Verificando...</h4>
        </template>
        <template v-if="!loading">
          <h1 class="texto">Ingresa tu código para acceder</h1>
          <br>
          <input type="text" v-model="codigo" class="cedula">
          <button class="boton" @click.prevent="validar">Ingresar</button>
        </template>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import Api from "@/services/Api";

export default {
  name: "Home",
  data() {
    return {
      codigo: "",
      loading: false,
      error: false
    };
  },
  methods: {
    validar() {
      
      this.loading = true;
      this.error = false;
      Api()
        .post("/validar", { codigo: this.codigo })
        .then(resp => {
          this.loading = false;
          this.$store.dispatch("setAuth", true);
          this.$router.push("/evento");
        })
        .catch(err => {
          this.loading = false;
          this.error = true;
        });
    }
  }
};
</script>
<style>
.v-progress-circular {
  display: block;
  margin: 0 auto;
}

.texto {
  text-align: center;
  color: #969696;
}

.boton {
  background-color: #6c757d;
  border-color: #6c757d;
  padding: 0.5rem 1rem;
  border: 1px solid #0000;
  margin: 0 auto;
  display: block;
  margin-top: 20px;
  line-height: 1.5;
  color: #fff;
  border-radius: 0.3rem;
}

.cedula {
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  height: calc(1.5em + 1rem + 2px);
  padding: 0.5rem 1rem;
  border-radius: 0.3rem;
  display: block;
  width: 100%;
}
</style>